import React from "react";
import { BookingPeriodMonthsDisplay } from "../../../../../store/BookingPeriod/Displays";
import { BookingPeriod } from "../../../../../store/BookingPeriod/Types";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { Grid } from "@vwpfs/mary-air-lib/components/air/03-base/Grid";
import { FieldTypes, FormField } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/Field";

interface OwnProps {
    details: BookingPeriod;
}

type Props = OwnProps;

/**
 *
 */
export class Detail
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);

    }

    public render() {
        return (
            <>
                <Div className="scl-b-row">
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            label="Starting date"
                            asSummary
                            value={this.props.details.startingDate}
                            type={FieldTypes.Date}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            label="Ending date"
                            asSummary
                            value={this.props.details.endingDate}
                            type={FieldTypes.Date}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            type={FieldTypes.Text}
                            value={this.props.details.status}
                            label="Status"
                            asSummary
                        />
                    </Grid>
                </Div>
                <Div className="scl-b-row">
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            type={FieldTypes.Text}
                            value={BookingPeriodMonthsDisplay[this.props.details.month]}
                            label="Month"
                            asSummary
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            type={FieldTypes.Number}
                            value={this.props.details.year}
                            label="Year"
                            asSummary
                        />
                    </Grid>
                </Div>
            </>
        );
    }
}


